import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";

// Unacknowledged active operational alerts, refreshed every minute (internal admins only).
export function OpsAlertBadge() {
  const api = useApi();
  const [n, setN] = useState(0);
  useEffect(() => {
    let live = true;
    const get = () => api.get("/admin/ops-alerts/summary").then(({ data }) => live && setN(data.unacked || 0)).catch(() => {});
    get();
    const t = setInterval(get, 60000);
    return () => { live = false; clearInterval(t); };
  }, [api]);
  if (!n) return null;
  return <span className="ml-auto rounded-full bg-red-500 px-1.5 text-[11px] font-semibold leading-5 text-white" data-testid="nav-ops-alert-badge">{n}</span>;
}
